import ThankyouModal from './ThankyouModal';
export default ThankyouModal;
